module.exports = __webpack_public_path__ + "static/img/modeling6.3d3a3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling6.png
// module id = QB47
// module chunks = 2